export const success = (isSuccess, message) => dispatch => dispatch({ type: 'SET_SUCCESS', isSuccess, message });
